import { Storage } from "aws-amplify";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  getTokenFromReducer,
  getUserDetailsFromReducer,
} from "Store/reducers/Auth/AuthSlice";
import { CreateTemplate } from "../../Utility/TemplateGenerator";

export const ProfilePreview = ({ data }) => {
  const userDetails = useSelector(getUserDetailsFromReducer);
  const token = useSelector(getTokenFromReducer);

  const generateWebsiteFromDataAndTemplate = async (data) => {
    const dataObj = {
      username: data?.username,
      name: data?.name,
      description: data?.description,
      logo: token
        ? await Storage.get(data?.logo)
        : `https://inprofile.co/${data?.username}/${data?.logoFilename}`,
      url: `https://inprofile.co/${data?.username}`,
      title: data?.name,
      phone: data?.phone,
      address: data?.address,
      email: data?.email,
      socials: {
        facebook: data?.facebook,
        instagram: data?.instagram,
        x: data?.x,
        linkedin: data?.linkedin,
        youtube: data?.youtube,
        pintrest: data?.pintrest,
        whatsapp: data?.whatsapp,
        googlemap: data?.googlemap,
        calendly: data?.calendly,
        tiktok: data?.tiktok,
        reddit: data?.reddit,
        buymeacoffe: data?.buymeacoffe,
      },
      services: data?.services,
      themeColor: data?.themeColor,
      action: data?.action ? JSON.parse(data?.action) : [],
      widgets: data?.widgets ? JSON.parse(data?.widgets) : [],
    };

    return CreateTemplate(dataObj);
  };

  const [template, settemplate] = useState("");
  useEffect(() => {
    const generate = async () => {
      let tmp = await generateWebsiteFromDataAndTemplate(data ?? userDetails);
      settemplate(tmp);
    };
    generate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userDetails, data]);
  return <div dangerouslySetInnerHTML={{ __html: template }}></div>;
};
